import { DataPoint, Record } from '@mtna/data-core-ts';
import { VariableGroup } from '@mtna/pojo-consumer-ts';

import { RdsVariableUtil } from './variable-util';

// @dynamic
export class RdsRecordUtil {
  static generateUniqueId(record: Record | undefined, primaryKey: VariableGroup | undefined) {
    if (!record || !primaryKey) {
      return '';
    }
    // Get they key of DataPoints
    // then join the values to form an ID
    return RdsRecordUtil.getKey(record, primaryKey)
      .map((dp) => dp.value?.value)
      .join();
  }

  static getKey(record: Record | undefined, primaryKey: VariableGroup | undefined): Array<DataPoint> {
    if (!record || !primaryKey) {
      return [];
    }
    // For each variable key, find the DataPoint in the record
    return primaryKey.variables.map(
      (keyVar) => record.data.find((d) => RdsVariableUtil.compareVariables(d.value?.variable, keyVar)) as DataPoint
    );
  }
}
